export default __webpack_public_path__ + "static/media/15.a0d27b75.jpg";